import { mapStores } from 'pinia';
import zhCn from 'element-plus/es/locale/lang/zh-cn';
import AppLoadingOverlay from '@/components/common/AppLoadingOverlay.vue';
import { useAppStore } from '@/store/app';
export default {
  name: 'App',
  components: {
    AppLoadingOverlay
  },
  data: () => ({
    locale: zhCn
  }),
  computed: {
    ...mapStores(useAppStore),
    isAdminRoute() {
      return this.$route.path.startsWith('/admin');
    }
  }
};